"use client";

import * as React from "react";
import { Inbox } from "lucide-react";
import { cn } from "@/lib/utils";
import { homeCardVariants } from "../foundations/home-variants";

export interface HomeEmptyStateV2Props {
  title: React.ReactNode;
  description?: React.ReactNode;
  icon?: React.ReactNode;
}

export function HomeEmptyStateV2({
  title,
  description,
  icon
}: HomeEmptyStateV2Props) {
  return (
    <div
      className={cn(
        homeCardVariants({ variant: "empty" }),
        "rounded-2xl p-8 text-center"
      )}
    >
      <div className="flex flex-col items-center gap-3">
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-slate-200 dark:bg-zinc-700">
          {icon || <Inbox className="h-7 w-7 text-slate-500 dark:text-zinc-300" />}
        </div>
        <div className="space-y-1.5">
          <h3 className="text-base font-medium text-slate-900 dark:text-zinc-100">{title}</h3>
          {description && (
            <p className="mx-auto max-w-sm text-sm text-slate-600 dark:text-zinc-400">{description}</p>
          )}
        </div>
      </div>
    </div>
  );
}
